import {} from "./HalfEdge.js";
export function halfEdgeEqual(x, y) {
    return x.id === y.id;
}
//# sourceMappingURL=halfEdgeEqual.js.map